import { useState, useEffect } from "react";
import { Table, Space, Button, Input, Modal, Tooltip, notification, Pagination } from "antd";
import { EyeOutlined, SearchOutlined, EditOutlined, DeleteOutlined, } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { GoArrowSwitch } from "react-icons/go";
import { customerService, driverService } from "../../../services";
import { checkPermission } from "../../../utils/permissions";
import { useDebounce } from "../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../utils/title";

function Drivers() {
    const editDriver = (id) => navigate(`/operations/driver/form/${id}`);
    const navigate = useNavigate();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalshow, setIsModalShow] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
    const [drivers, setDrivers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });
    const [search, setSearch] = useState(null)
    const debouncedSearch = useDebounce(search, 500);

    const columns = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            render: (text) => <p>{text ? text : "-"}</p>,
        },
        {
            title: "Country",
            dataIndex: "country",
            key: "country",
            render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
        },
        {
            title: "Agreement",
            dataIndex: "document",
            key: "document",
            render: (_, record) => (
                <div style={{ padding: "5px" }}>
                    {record.isContractSign === 1 ? (
                        <Link
                            to={`/customers-portal/term-&-condition/${record.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p
                                style={{
                                    border: "1px solid #ccc",
                                    backgroundColor: "#2D3748",
                                    padding: "5px",
                                    borderRadius: "12px",
                                    color: "white",
                                }}
                            >
                                Agreement
                            </p>
                        </Link>
                    ) : (
                        <p>-</p>
                    )}
                </div >
            ),
        },
        {
            title: "Status & Action",
            key: "isActive",
            render: (_, record) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                    }}
                >
                    <span
                        style={{
                            color: record.isActive === 1 ? "green" : "red",
                            fontWeight: "bold",
                        }}
                    >
                        {record.isActive === 1 ? "Active" : "Inactive"}
                    </span>
                    <Button
                        style={{
                            backgroundColor: "#2D3748",
                            color: "white",
                            borderRadius: "10px",
                        }}
                        onClick={() => showModalHandler(record)}
                        size="small"
                    >
                        <GoArrowSwitch style={{ fontSize: "15px" }} />
                    </Button>
                </div>
            ),
        },
        {
            title: "Action",
            key: "Action",
            render: (text, record) => (
                <Space size="small">
                    {checkPermission('EDIT_CUSTOMER') && <Tooltip title='Edit'>
                        {/* <Button
                            type="primary"
                            size="small"
                            onClick={() => editDriver(record.id)}
                        > */}
                        <EditOutlined onClick={() => editDriver(record.id)}
                        />
                        {/* </Button> */}
                    </Tooltip>}

                    {checkPermission('VIEW_DRIVER') && <Tooltip title='View'>
                        {/* <Button
                            type="primary"
                            size="small"
                            onClick={() => navigate("/operations/driver/view/" + record.id)}
                        > */}
                        <EyeOutlined onClick={() => navigate("/operations/driver/view/" + record.id)}
                        />
                        {/* </Button> */}
                    </Tooltip>}

                    {checkPermission("DELETE_DRIVER") && <Tooltip title='Delete'>
                        {/* <Button
                            type="primary"
                            size="small"
                            onClick={() => showModal(record)}
                        > */}
                        <DeleteOutlined onClick={() => showModal(record)}
                        />
                        {/* </Button> */}
                    </Tooltip>}

                </Space>
            ),
        },
    ];

    const showModalHandler = (record) => {
        setSelectedRecord(record);
        setIsModalVisible(true);
    };

    const showModal = (record) => {
        setSelectedDeleteRecord(record);
        setIsModalShow(true);
    };

    const handleCancel = () => {
        setIsModalShow(false);
        setIsModalVisible(false);
        setSelectedRecord(null);
    };

    const initialize = async (page = 1, pageSize = pagination.pageSize) => {

        setLoading(true);
        const response = await driverService.driverGet(page, pageSize, debouncedSearch);
        setLoading(false);

        if (response?.success ?? false) {
            setDrivers(response.data.data);
            setPagination((prev) => ({
                ...prev,
                total: response.data.total,
                current: page,
                pageSize,
            }));
        }
    };

    const handleDelete = async () => {
        setDeleteLoading(true)
        if (!selectedDeleteRecord || !selectedDeleteRecord.id) {
            console.error("No driver selected for deletion.");
            return;
        }
        const response = await driverService.delete(selectedDeleteRecord.id);
        setDeleteLoading(false)
        if (response.success) {
            notification.success({
                message: "Driver Deleted.",
                placement: "topRight"
            })
            initialize();
        } else {
            console.error("Failed to delete the driver.");
        }
        setIsModalShow(false);
    };


    const handleOk = async () => {
        if (!selectedRecord) return;
        setLoading(true);
        const response = await customerService.fetchCustomerStatus(
            selectedRecord.id
        );
        if (response.success) {
            setDrivers((prevData) =>
                prevData.map((item) =>
                    item.id === selectedRecord.id
                        ? { ...item, isActive: item.isActive === 1 ? 0 : 1 }
                        : item
                )
            );
            // initialize(pagination.current, pagination.pageSize);
            setLoading(false);
            setIsModalVisible(false);
            setSelectedRecord(null);
        }
    };

    useEffect(() => {
        changeDocumentTitle('Drivers')

        initialize(pagination.current, pagination.pageSize);
    }, [debouncedSearch]);

    const renderStatusModal = (
        <>
            <Modal
                title={<div style={{ textAlign: "center" }}>Confirm</div>}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                styles={{
                    body: {
                        padding: "20px", // Adjust padding for smaller size
                    },
                }}
                width={300}
                footer={
                    <div className="flex justify-center gap-3">
                        <Button
                            type="default"
                            onClick={handleCancel}
                            style={{ width: "30%" }}
                        >
                            No
                        </Button>
                        <Button type="primary" loading={loading} onClick={handleOk} style={{ width: "30%" }}>
                            Yes
                        </Button>
                    </div>
                }
            >
                <div style={{ textAlign: "center" }}>Do you want to change status?</div>
            </Modal>
        </>
    );

    const renderDeleteModal = (
        <>
            <Modal
                title={<div style={{ textAlign: "center" }}>Confirm</div>}
                open={isModalshow}
                onOk={handleDelete}
                onCancel={handleCancel}
                centered
                styles={{
                    body: {
                        padding: "20px",
                    },
                }}
                width={300}
                footer={
                    <div className="flex justify-center gap-3">
                        <Button
                            type="default"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleDelete}
                            loading={deleteLoading}
                        >
                            Confirm
                        </Button>
                    </div>
                }
            >
                <p style={{ textAlign: "center" }}>
                    Are you sure you want to delete this?
                </p>
            </Modal>
        </>
    );

    return (
        <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>

            <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">Browse Drivers</h1>

            <div className="flex justify-end">
                <Input
                    placeholder="Search by name & email"
                    prefix={<SearchOutlined />}
                    style={{
                        width: "25%",
                        borderRadius: "20px",
                        fontSize: 14,
                        margin: 10
                    }}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={drivers}
                loading={loading}
                // pagination={{
                //     current: pagination.current,
                //     total: pagination.total,
                //     pageSize: pagination.pageSize,
                //     onChange: (page) => initialize(page, pagination.pageSize),
                //     showSizeChanger: false,
                // }}
                pagination={false}
                style={{ marginTop: "10px" }}
                footer={() => (
                    <div className="flex justify-between items-center text-xs ">
                        <div className=" text-gray-600">
                            Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                            {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                            {pagination.total} entries
                        </div>
                        <Pagination
                            current={pagination.current}
                            total={pagination.total}
                            pageSize={pagination.pageSize}
                            showSizeChanger={false}
                            onChange={(page) => initialize(page, pagination.pageSize, search)}
                            itemRender={(current, type, originalElement) => {
                                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                return originalElement;
                            }}
                        />
                    </div>
                )}
            />

            {renderStatusModal}

            {renderDeleteModal}
        </div>
    );
}

export default Drivers;
